import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoginCard, LoginFormFields, useLoginForm } from 'shared-ui';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const form = useLoginForm(login, () => navigate('/'));

  return (
    <LoginCard title="Social Circle" subtitle="Your circle's chat and calendar, together" error={form.error}>
      <LoginFormFields {...form} />
    </LoginCard>
  );
};

export default Login;
